module.exports = __webpack_public_path__ + "img/DE00561.347033ee.png";